import React from 'react';
import style from './style.module.scss';
import { openZendeskWidget } from 'utilities/zendesk';
import CancelOption from './cancel_option';

interface Props {
  date: string;
  timeDistance: string;
}

export default (props: Props) => {
  return (
    <div className={style.greenBorder}>
      <div className={style.top}>
        <h3 className={style.planHeader}>
          <strong>Practice test set</strong> for {props.date}
        </h3>
        <CancelOption />
      </div>
      <p>
        You have {props.timeDistance} of studying before your next practice test. <br />
        Need advice on what to focus on?{' '}
        <a onClick={openZendeskWidget}>Connect with a GRE test prep expert</a>
      </p>
    </div>
  );
};
